/**
 * Created by Windows Mario Luna on 22/10/2018.
 */

export class ProductoModel {
  Id: number;
  Producto: string;
  Basis: boolean;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-edit-producto-dialog/producto-class.ts